function modal() {
	const modalCloseButtons = document.querySelectorAll(".modal-close");
	const modalButton = document.querySelectorAll("[data-modal]");
	const links = document.querySelectorAll('a[href*="#"]');

	modalButton.forEach(function (e) {
		e.addEventListener("click", (event) => {
			var modalNum = event.target.getAttribute("data-modal");
			let modal = document.querySelector(`[data-modal-content="${modalNum}"]`);
			modal.classList.add("modal-show");
		});
	});

	links.forEach((link) => {
		let modal = document.querySelector(`[data-modal-content="${link.getAttribute('href').replace('#', '')}"]`);
		if(modal) {
			link.addEventListener('click', (event) => {
				event.preventDefault();
				modal.classList.add("modal-show");
			});
		}
	});

	function toggleModal(modalId) {
		const modal = document.getElementById(modalId);
		const uuid = modal.getAttribute("data-modal-content");
		// const iframe = document.querySelector(`.vidyard-iframe-${modalId}`);
		var players = VidyardV4.api.getPlayersByUUID(uuid);
		if (getComputedStyle(modal).display === "flex") {
			modal.classList.add("modal-hide");
			if (players[0]) {
				players[0].pause();
			}
			setTimeout(() => {
				document.body.style.overflow = "initial";
				modal.classList.remove("modal-show", "modal-hide");
				modal.style.display = "none";
			}, 200);
		} else {
			document.body.style.overflow = "hidden";
			modal.style.display = "flex";
			modal.classList.add("modal-show");
		}
	}

	modalCloseButtons.forEach((elem) => {
		elem.addEventListener("click", (event) =>
			toggleModal(event.currentTarget.closest(".modal").id)
		);
	});

	// Close Modal with "Esc"...
	document.addEventListener("keydown", (event) => {
		if (event.keyCode === 27 && document.querySelector(".modal.modal-show")) {
			toggleModal(document.querySelector(".modal.modal-show").id);
		}
	});
}

export default modal;
